import { MediaProgram, RbcReason } from '@calm/evexia-web-sdk';
import React from 'react';

export interface LearnWhyProps {
    isTopRecommendation: boolean;
    reason: RbcReason;
    packClass: string;
    program: MediaProgram;
}

export enum MatchingPod {
    Goals,
    Topics,
    Conditions,
}

interface MatchingChoice {
    icon: React.JSX.Element;
    label: string;
    displayName?: string;
    category?: {
        id: string;
        name: string;
    };
}

export interface MatchingChoicesPodData {
    totalCount: number;
    matchingChoices: MatchingChoice[];
}
